import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import { THEME } from '@/styles/theme';
import styled from 'styled-components';

export const BannerWrapper = styled.div<{ background?: string }>`
  ${flex()};
  position: relative;
  padding: 12px 36px;
  background: ${({ background }) =>
    background ? `${background}` : 'linear-gradient(89.99deg, #aaf4eb 0.01%, #c9d5ff 99.99%)'};
  z-index: ${THEME.banner.zIndex};

  ${media.tablet`
    padding: 8px 16px;
  `}
`;
